import { LIST_REQUIRED_STATUSES } from "../../required-values";

export default {
    NETWORK_ERROR: {
        TITLE: "Network Error",
        MESSAGE: "Please check your internet connection and make sure it is good. If it seems fine please wait a couple of minutes, close this message and try again (do not refresh or you may lose what you entered)."
    },
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: 'Missing field for Email Address',
        MESSAGE: 'Please add at least 1 field for email address!'
    },
    INVALID_INPUT_ERROR: {
        INNER_HTML: `
        <h2>A required field is missing or a field is invalid.</h2>
        <h4 class="error-message main-message">
        Please review the form for error messages!
        </h4>
        <h5>{0}</h5>
        `
    },
    LOGIN_MISSING_EMAIL_ERROR: {
        TITLE: 'Email address is missing',
        MESSAGE: 'Please input email address!'
    },
    LOGIN_MISSING_PASSWORD_ERROR: {
        TITLE: 'Password is missing',
        MESSAGE: 'Please input password!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Booking time is missing',
        MESSAGE: 'Please add booking time (Start Time and End Time)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'A document is not signed',
        MESSAGE: 'Please review the form for error messages and sign all documents!'
    },
    MISSING_EVALUATION_ERROR: {
        TITLE: 'An evaluation is not complete',
        MESSAGE: 'Please review the form for error messages and complete all evaluation!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'An input field is invalid',
        MESSAGE: 'There is an input field which is invalid'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'There is no field for the builder',
        MESSAGE: 'Please add at least one field!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'Cannot use same option between {0} and {1}',
        MESSAGE: 'Please unselect option(s) {2} in {0} or {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: 'Please add more {0}!',
        MESSAGE: 'You must have at least {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Experience is lacking',
        MESSAGE: 'You must have at least 1 experience.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Statuses is lacking',
        MESSAGE: `${LIST_REQUIRED_STATUSES.join(" and ")} are required statuses`
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some statuses which are duplicated'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Multi fields using the same model',
        MESSAGE: 'There is a model which is assigned to at least 2 fields'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some items which are duplicated'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'Employer type is duplicated',
        MESSAGE: 'There are some employer type which are duplicated'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'Candidate type is duplicated',
        MESSAGE: 'There are some candidate type which are duplicated'
    },
    DUPLICATE_JOB_TYPE_ERROR: {
        TITLE: 'Job types is duplicated',
        MESSAGE: 'There are some job types which are duplicated'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a PNG or JPG image.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a DOC or DOCX or PDF file.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: 'File is empty!',
        MESSAGE: 'Please upload a non empty file'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: 'File too big!',
        MESSAGE: 'Please upload a file with a size below the maximum upload size.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Invalid File',
        MESSAGE: 'Invalid input file'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Your professional childcare resume is missing',
        MESSAGE: 'Please upload your professional childcare resume'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'End date must be after start date',
        MESSAGE: 'Please change start date or end date'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Bookings must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Your profile picture is missing',
        MESSAGE: 'Please upload a recent photo of yourself!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'No text selected',
        MESSAGE: 'Please select some text'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Your application has been submitted! BUT',
        MESSAGE: 'There was an error processing your references. Can you please email them to us? Thanks!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Failed to submit your application',
        MESSAGE: 'There was an error processing your application'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Missing item in status list',
        MESSAGE: 'Status {0} is required'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'There is an incomplete section',
        MESSAGE: 'Section {0} is incomplete. Please update that section'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Passwords do not match.'
    },
    INVALID_PHONE_NUMBER_ERROR: {
        TITLE: "Invalid phone number",
        MESSAGE: "The phone number {0} is invalid. Please correct it"
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'Unable to find nearby Candidates',
        MESSAGE: 'Job is missing a full address. To search for candidates Edit Job and fill missing address info'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'The profile builder is in used',
        MESSAGE: 'The profile builder is being used by the profile builder {0}.\n' +
            'Please remove that profile builder first'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'A signature is missing',
        MESSAGE: 'Please type your name to sign'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'A required field is missing',
        MESSAGE: 'Please fill all of the required fields (Please check the red border fields)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: `
        <h2>It looks like you are already in our system!</h2>
        <h4 class="error-message main-message">
        Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!
        </h4>
        `
    },
    FORCE_LOGOUT_ERROR_DIALOG: {
        TITLE: 'You were logged out!',
        MESSAGE: 'Sorry, you were logged out by a log into this account by another device.',
    },
    WEEK_AVAILABILITY_BLOCK_END_TIME_BEFORE_START_TIME_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time of block {0} of {1}'
    },
    WEEK_AVAILABILITY_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Block must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time of block {1} of {2}'
    },
    WEEK_AVAILABILITY_EMPTY_REQUIRED_FIELD_ERROR: {
        TITLE: 'Empty required field',
        MESSAGE: 'Please fill both start time and end time of block {0} of {1}'
    },
    PAYMENT_INFORMATION_REQUIRED: {
        TITLE: "Payment Information is required",
        MESSAGE: "Please input payment information"
    },
    INVALID_PAYMENT_INFORMATION: {
        TITLE: "Invalid Payment Information",
        MESSAGE: "Please update payment information: {0}"
    },
    PAYMENT_INFORMATION_INVALID: {
        TITLE: "Invalid Payment Information",
        MESSAGE: "Please update payment information"
    },
    LIST_INPUT_CONTAINS_BLANK: {
        TITLE: "{0} contains blank value",
        MESSAGE: "Please remove the blank {0}"
    },
    DUPLICATE_HEADER_IMPORT_CSV: {
        TITLE: "There are some duplicated headers.",
        MESSAGE: "List of duplicate headers: {0}.\nIf the duplicated headers are imported, the corresponding fields may not be imported"
    },
    CANNOT_EDIT_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Cannot Edit the Booking",
        MESSAGE: "Sorry, changed cannot be made less than {0} hours before a job starts. If you require a change, please contact us directly. Thank you!"
    },
    CANNOT_ADD_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Cannot Add the Booking",
        MESSAGE: "Sorry, cannot book less than {0} hours before a job starts. If you really need this, please contact us directly. Thank you!"
    },
    PAYMENT_FIELD_REQUIRED_IN_APPLICATION_FORM: {
        TITLE: "Payment field is required",
        MESSAGE: "Please add payment field to be able to charge user when submit application form"
    },
    MISSING_NUMBER_OF_ROWS: {
        TITLE: 'Please specify number of rows for partial import'
    },
    SCHEDULE_CONFLICT_CANDIDATE_ERROR_DIALOG: {
        TITLE: "Schedule conflict",
        MESSAGE: "You are already assigned to another job during that time"
    },
    JOB_NO_LONGER_AVAILABLE_ERROR_DIALOG: {
        TITLE: "This job is no longer available",
    },
    CLIENT_CONFIRM_INCORRECT_PASSWORD: {
        TITLE: "Incorrect password",
        MESSAGE: "Failed to approve the clock in/out time. Client password is incorrect"
    },
    HAS_MISSING_SECTION_BUILDER_ERROR_DIALOG: {
        TITLE: "There is a missing section builder",
        MESSAGE: "The profile builder was imported successfully. However, there is a missing selection of the section builder (field label: {0}). Please Edit the builder to correct it"
    },
    CLOCK_OUT_CLIENT_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Thanks!",
        MESSAGE: "Client did not input payment information. We will process the payment later.\n" +
            " If there were any issues with recording the time, or anything else, please let us know."
    },
    CLOCK_OUT_CANDIDATE_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Thanks!",
        MESSAGE: "Candidate did not input payment information. We will process the payment later. Please input your payment information to get paid through Stripe\n" +
            " If there were any issues with recording the time, or anything else, please let us know."
    },
    CLOCK_OUT_MISSING_PAYMENT_INFORMATION: {
        TITLE: "Thanks!",
        MESSAGE: "Missing payment information. We will process the payment later.\n" +
            " If there were any issues with recording the time, or anything else, please let us know."
    },
    SCHEDULE_TIME_IN_PAST: {
        TITLE: "The specified time is in the past. Please select another time"
    },
    ACTION_MISSING_DATE_FIELD: {
        TITLE: "Please select date"
    },
    APPLICATION_FORM_DUPLICATED_PHONE: {
        TITLE: "Warning!",
        MESSAGE: "Your phone number is already in the system, have you worked with us before? If so, please contact us and we can help you access your existing account!"
    },
    APPLICATION_FORM_DUPLICATED_EMAIL: {
        TITLE: "Warning!",
        MESSAGE: "Your email address is already in the system, have you worked with us before? If so, please contact us and we can help you access your existing account!"
    },
    INVALID_AMOUNT_ERROR: {
        TITLE: "Invalid amount"
    },
    NON_NUMBER_INPUT_ERROR: {
        TITLE: "Please input a number"
    },
    SEND_EMAIL_TOO_LONG_DURATION_ERROR_DIALOG: {
        TITLE: "Scheduling more than 8 hours is not supported"
    },
    APPLICATION_FORM_USER_SUBMITTED: {
        TITLE: "User submitted the application form"
    },
    APPLICATION_FORM_USER_INCORRECT_USER_ID: {
        TITLE: "Incorrect user id",
        MESSAGE: "Please contact your agency to get the correct URL"
    },
    NO_JOB_POSTER_ERROR_DIALOG: {
        TITLE: "Job has no poster information"
    },
    RETURNING_APPLICANT_EMAIL_NOT_FOUND: {
        TITLE: "Email Address is not found",
        MESSAGE: "Sorry, we could not find this in our system. Please try a different email or contact us if you have any questions"
    },
    RETURNING_APPLICANT_INCORRECT_CODE: {
        TITLE: "Incorrect Code",
        MESSAGE: "The inputted verification code is incorrect. Please try again later"
    },
    SHIFT_JOB_REPORT_IS_REQUIRED: {
        TITLE: "Shift Job Report required",
        MESSAGE: "Please submit shift job report before clocking out"
    },
    TIMEOFF_REQUEST_ON_ASSIGNED_DATES_ERROR: {
        TITLE: "Failed to submit timeoff request",
        MESSAGE: "You are assigned to a job on {0}! Please contact us directly if you need time off then."
    },
    NOT_ALLOW_MOVE_FIELD_ERROR_DIALOG: {
        TITLE: "Cannot move that field",
        MESSAGE: "That is a special field, and cannot be moved in the application form"
    },
    INVALID_LINK_ERROR_DIALOG: {
        TITLE: "The link is invalid"
    },
    MISSING_DATE_OF_ADDITIONAL_DATES_ERROR_DIALOG: {
        TITLE: "Missing date of additional dates",
        MESSAGE: "Please specify date of each additional dates"
    },
    CAPTCHA_NOT_COMPLETED: {
        TITLE: "Please complete the Captcha"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/error-dialog/en.js